module.exports = __webpack_public_path__ + "img/no-plc-ship.67d828db.svg";